/** Which machines and which people Home's LOLER exam rows cover, shared by web and native so the two cannot drift. */
import type {PlantAsset} from '../../types/plant';

// Not clients, not Field-only members: the plant register is office material.
const PLANT_ROLES = new Set(['super_admin', 'internal', 'admin', 'staff', 'workspace_owner', 'workspace_admin']);
export const canReadHomePlant = (role: string | undefined | null, workspaceId: string | undefined | null): boolean =>
  !!role && !!workspaceId && PLANT_ROLES.has(role);

// Only machines that are lifting and need a LOLER exam can have one coming up.
export const lolerMachines = (rows: readonly PlantAsset[]): PlantAsset[] =>
  rows.filter((asset) => asset.lolerRequired && asset.status === 'active');
